// noinspection JSUnfilteredForInLoop

export default class Presence {

  _byGeofence = {};
  _byDevice = {};

  constructor(data) {
    this._byGeofence = data;
    for(let gId in data) {
      for(let dId in data[gId]) {
        if(!this._byDevice[dId]) this._byDevice[dId] = {};
        this._byDevice[dId][gId] = !!data[gId][dId];
      }
    }
  }

  byGeofence(gId) {
    return this._byGeofence[gId] || {};
  }
  byDevice(dId) {
    return this._byDevice[dId] || {};
  }

  presentDevices(gId, devices) {
    const deviceIds = Object.keys(this.byGeofence(gId)).filter(dId => this.byGeofence(gId)[dId]).map(dId => +dId);
    return devices.filter(d => deviceIds.indexOf(d.id) >= 0 && d.connected);
  }

}

// V4 has no presence stream; each geofence member carries a live `present` flag.
export function v4GeofenceMembers(geofence) {
  const members = geofence?.get?.('v4Data')?.members || geofence?.v4Data?.members || [];
  return new Map(members
    .filter(m => m && m.active !== false && m.device_id)
    .map(m => [String(m.device_id), m]));
}

const v4DeviceKey = d => String(d.get?.('uuid') || d.uuid || d.id);

// Same split as GeofenceAttendance; web users are left out.
export function v4GeofenceAttendance(geofence, devices) {
  const members = v4GeofenceMembers(geofence);
  const linked = devices.filter(d => !d.isWebUser && members.has(v4DeviceKey(d)));
  const isPresent = d => d.connected && members.get(v4DeviceKey(d)).present !== false;
  return {
    presentAndConnected: linked.filter(isPresent),
    absentOrDisconnected: linked.filter(d => !isPresent(d)),
  };
}

export function presentDeviceCount(presence, geofence, devices) {
  if (!geofence?.isV4) {
    return presence?.presentDevices ? presence.presentDevices(geofence.id, devices).size : 0;
  }
  return v4GeofenceAttendance(geofence, devices).presentAndConnected.size;
}

// Geofence id -> present, from the V3 stream and V4 members.
export function deviceGeofencePresence(presence, device, geofences) {
  const byGeofence = { ...(presence?.byDevice ? presence.byDevice(device.id) : {}) };
  const key = v4DeviceKey(device);
  geofences.forEach(g => {
    const member = g?.isV4 && v4GeofenceMembers(g).get(key);
    if (member) byGeofence[g.id] = member.present !== false;
  });
  return byGeofence;
}
